import React from 'react'
import SwipeableDrawer from 'jd-library/SwipeableDrawer'
import loadable from '@loadable/component';
// const UploadDropdownOptions = loadable(() => import(/* webpackChunkName: "dropdown-options-web" */ './DropdownOptionsWeb'))
import UploadDropdownOptions from './DropdownOptionsWeb';

export default (props) => {
	return props.isMobile ? (
		<SwipeableDrawer {...props} />
	) : (
		<UploadDropdownOptions {...props} />
	)
}
